import { styled } from '@mui/material';
import { ContentWrapper } from '../../../styles/shared';
import { getCompany } from '../../../utils/company';
import { Companies } from '../../../models/domain/enum';

const company = getCompany();

const getGalleryWrapperStyles = (theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {
        border: `0px solid ${theme.colors.border}`,
        paddingTop: theme.spacings.unit(4),
        paddingBottom: theme.spacings.unit(4),
        [theme.breakpointsMediaQuery.up('md')]: {
          border: `1px solid ${theme.colors.border}`,
          padding: `${theme.spacings.unit(10)} ${theme.spacings.unit(20)}`,
        },
      };
    case Companies.FELSINEA:
      return {};
    default:
      return {};
  }
};

const getVideoWrapperStyles = (theme: any) => {
  switch (company) {
    case Companies.SIRMAN:
      return {};
    case Companies.FELSINEA:
      return {
        '& > h2': {
          color: theme.colors.secondaryText,
          fontSize: theme.fonts.utility.size(10),
          fontWeight: 700,
          lineHeight: '140%',
          letterSpacing: theme.spacings.unit(-0.025),
          marginBottom: theme.spacings.unit(6),
        },
      };
    default:
      return {};
  }
};

export const StyledContentWrapperSrm = styled(ContentWrapper)(({ theme }) => ({
  color: theme.colors.secondaryText,
  '@media print': {
    display: 'none',
  },
}));

export const StyledContentWrapperFls = styled('div')(({ theme }) => ({
  color: theme.colors.secondaryText,
  '@media print': {
    display: 'none',
  },
}));

export const StyledContentWrapper: any = (() => {
  switch (company) {
    case Companies.SIRMAN:
      return StyledContentWrapperSrm;
    case Companies.FELSINEA:
      return StyledContentWrapperFls;
    default:
      return StyledContentWrapperSrm;
  }
})();

export const GalleryWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.colors.background,
  marginTop: 0,
  ...getGalleryWrapperStyles(theme),
}));

export const VideoWrapper = styled('div')(({ theme }) => ({
  flex: 1,
  ...getVideoWrapperStyles(theme),
}));

export const IFrame = styled('iframe')(({ theme }) => ({
  width: '520px',
  height: '315px',
  [theme.breakpointsMediaQuery.down('sm')]: {
    width: '100%',
    height: '250px',
  },
}));
